import { render, staticRenderFns } from "./PuiMainPage.vue?vue&type=template&id=33a01cc5&scoped=true&"
import script from "./PuiMainPage.vue?vue&type=script&lang=js&"
export * from "./PuiMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a01cc5",
  null
  
)

export default component.exports